import { updateAthlete, updateAthleteProfile } from "api-client";

import { athleteProfileQueryOptions } from "src/queries/athletes";

import { type AthletesRepository } from "./AthletesRepository";

export function createPrivateAthletesRepository(): AthletesRepository {
  return {
    profileOptions: athleteProfileQueryOptions,
    async updateProfile(athleteId, { name, ...input }) {
      if (name !== undefined) {
        await updateAthlete({ path: { athleteId }, body: { name } });
      }

      return updateAthleteProfile({ path: { athleteId }, body: input });
    },
  };
}
